import React, { useState } from 'react';
import { motion } from 'framer-motion';

const ProductCard = ({ id, title, description, price, features = [], delay = 0, tag = "CORDYCEPS MILITARIS", image = "/media/whole.jpg", onAddToCart }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: delay * 0.08, duration: 0.5 }}
      whileHover={{ y: -6 }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        background: isHovered ? '#101010' : '#080808',
        borderRadius: '12px',
        padding: '28px',
        border: isHovered ? '1px solid #ffffff' : '1px solid #222222',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        transition: 'border-color 0.3s, background 0.3s'
      }}
    >
      <div style={{
        position: 'absolute',
        top: '18px',
        right: '18px',
        background: '#151515',
        border: '1px solid #333333',
        color: '#ffffff',
        fontSize: '0.65rem',
        fontWeight: 700,
        padding: '4px 10px',
        borderRadius: '4px',
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        zIndex: 2
      }}>
        {tag}
      </div>

      <div style={{
        height: '220px',
        background: '#040404',
        borderRadius: '8px',
        marginBottom: '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #161616',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <motion.img
          animate={{
            scale: isHovered ? 1.06 : 1
          }}
          transition={{ duration: 0.4 }}
          src={image}
          alt={title}
          onError={(e) => { e.target.src = "/media/whole.jpg"; }}
          style={{
            height: '100%',
            width: '100%',
            objectFit: 'cover',
            display: 'block'
          }}
        />
      </div>

      <h3 style={{
        fontSize: '1.25rem',
        marginBottom: '10px',
        color: '#ffffff',
        letterSpacing: '-0.03em',
        lineHeight: 1.3,
        fontWeight: 800
      }}>
        {title}
      </h3>

      <div style={{
        fontSize: '1.3rem',
        fontWeight: 900,
        color: '#ffffff',
        marginBottom: '14px',
        letterSpacing: '-0.02em'
      }}>
        {price}
      </div>

      <p style={{
        color: '#888888',
        fontSize: '0.9rem',
        lineHeight: 1.6,
        marginBottom: '24px',
        flex: 1
      }}>
        {description}
      </p>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '28px' }}>
        {features.map((feature, idx) => (
          <span
            key={idx}
            style={{
              background: '#121212',
              border: '1px solid #282828',
              color: '#cccccc',
              fontSize: '0.72rem',
              padding: '4px 10px',
              borderRadius: '4px',
              fontWeight: 600
            }}
          >
            {feature}
          </span>
        ))}
      </div>

      <button
        onClick={() => onAddToCart && onAddToCart()}
        style={{
          width: '100%',
          padding: '14px',
          background: isHovered ? '#ffffff' : '#141414',
          color: isHovered ? '#000000' : '#ffffff',
          border: isHovered ? '1px solid #ffffff' : '1px solid #333333',
          borderRadius: '6px',
          fontWeight: 700,
          textTransform: 'uppercase',
          fontSize: '0.82rem',
          letterSpacing: '0.08em',
          transition: 'all 0.25s',
          cursor: 'pointer'
        }}
      >
        Pre-order
      </button>
    </motion.div>
  );
};

export default ProductCard;
